import { Button, Center, Heading, Stack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { Logo } from '../Logo';
import { Illustration404 } from './Illustration404';

type FallbackErrorPageProps = {
  error: string;
  componentStack: string;
  eventId: string;
};

export const ErrorPage400 = ({
  error,
  componentStack,
  eventId,
}: FallbackErrorPageProps) => {
  const { t } = useTranslation(['common', 'auth']);
  const env = import.meta.env;

  // Detect dynamic import failure (offline chunk load)
  const isDynamicImportOfflineError =
    error &&
    error.startsWith('Failed to fetch dynamically imported module:') &&
    navigator &&
    navigator.onLine === false;

  return (
    <Center flexDir="column" height="100vh" p="8">
      {isDynamicImportOfflineError ? (
        <Stack align="center" spacing={8}>
          <Logo my={4} />
          <Heading fontSize={36} color="red.500" textAlign="center">
            {t('common:youAreOffline')}
          </Heading>
          <Text fontSize={20} color="gray.500" textAlign="center">
            {t('common:actions.checkInternet')}
          </Text>
        </Stack>
      ) : (
        <>
          <Stack
            direction={{ base: 'column-reverse', md: 'row' }}
            align="center"
            spacing={4}
          >
            <Illustration404 />
            <Stack
              textAlign={{ base: 'center', md: 'left' }}
              alignItems={{ base: 'center', md: 'flex-start' }}
            >
              <Logo my={4} />
              <Heading fontSize={24}>
                {t('common:error.page.title.400')}
              </Heading>
              <Text fontSize={18}>{t('common:error.page.message.400')}</Text>
              <Button
                onClick={() => window.history.go(-1)}
                mt={5}
                size="sm"
                variant="@primary"
              >
                <Text fontSize="sm">{t('common:actions.goBack')}</Text>
              </Button>
            </Stack>
          </Stack>
          {env.MODE !== 'production' && (
            <Stack mt={5}>
              <Heading display="flex" columnGap={2} fontSize={22}>
                {error}
              </Heading>
              <Text>
                <Text as="span" fontWeight={700}>
                  Stack trace:
                </Text>
                {componentStack}
              </Text>
              <Text>
                <Text as="span" fontWeight={700}>
                  event id
                </Text>{' '}
                : {eventId}
              </Text>
            </Stack>
          )}
        </>
      )}
    </Center>
  );
};
